

export function hydrator(parameters, data, chart) {
  
}
